module.exports = __webpack_public_path__ + "static/media/share_person3.51992c07.png";